// extracted by mini-css-extract-plugin
export default {"root":"Search_root__oKXP6","input":"Search_input__feuaJ","searchBtn":"Search_searchBtn__ijz0j"};